module.exports = __webpack_public_path__ + "img/cart_off-brands.92c14da6.jpg";